let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kSNuI")).then(() => parcelRequire('4cmmO'));